import React from 'react';
export const HowItWorksSection = () => {
  return <section className="py-24 md:py-32 bg-white relative z-10" data-id="element-86">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl" data-id="element-87">
        <div className="text-center mb-16 md:mb-20" data-id="element-88">
          <h2 className="text-4xl md:text-5xl font-semibold mb-4 tracking-tight text-[#111928]" data-id="element-89">
            How It Works
          </h2>
        </div>

        <div className="space-y-24 md:space-y-32" data-id="element-90">
          {/* Section 1: On the Client's End */}
          <div className="grid md:grid-cols-[1fr_1.5fr] gap-12 md:gap-20 items-start" data-id="element-91">
            {/* Left column - heading */}
            <div className="max-w-md" data-id="element-92">
              <h3 className="text-3xl md:text-4xl font-semibold text-[#186447] mb-6 tracking-tight" data-id="element-93">
                On the Client's End
              </h3>
            </div>

            {/* Right column - list */}
            <div className="space-y-8" data-id="element-94">
              <div className="flex gap-4 group" data-id="element-95">
                <div className="flex-shrink-0 mt-1" data-id="element-96">
                  <div className="w-12 h-12 rounded-xl bg-[#EFFAF5] flex items-center justify-center group-hover:bg-[#186447] transition-colors" data-id="element-97">
                    <span className="text-xl font-semibold text-[#186447] group-hover:text-white transition-colors" data-id="element-98">
                      1
                    </span>
                  </div>
                </div>
                <div data-id="element-99">
                  <p className="text-base text-[#6B7280] leading-relaxed" data-id="element-100">
                    They upload photos and share their routine and treatment
                    history.
                  </p>
                </div>
              </div>

              <div className="flex gap-4 group" data-id="element-101">
                <div className="flex-shrink-0 mt-1" data-id="element-102">
                  <div className="w-12 h-12 rounded-xl bg-[#EFFAF5] flex items-center justify-center group-hover:bg-[#186447] transition-colors" data-id="element-103">
                    <span className="text-xl font-semibold text-[#186447] group-hover:text-white transition-colors" data-id="element-104">
                      2
                    </span>
                  </div>
                </div>
                <div data-id="element-105">
                  <p className="text-base text-[#6B7280] leading-relaxed" data-id="element-106">
                    You prepare a structured facial analysis and personalized
                    draft plan that will be sent to the client.
                  </p>
                </div>
              </div>

              <div className="flex gap-4 group" data-id="element-107">
                <div className="flex-shrink-0 mt-1" data-id="element-108">
                  <div className="w-12 h-12 rounded-xl bg-[#EFFAF5] flex items-center justify-center group-hover:bg-[#186447] transition-colors" data-id="element-109">
                    <span className="text-xl font-semibold text-[#186447] group-hover:text-white transition-colors" data-id="element-110">
                      3
                    </span>
                  </div>
                </div>
                <div data-id="element-111">
                  <p className="text-base text-[#6B7280] leading-relaxed" data-id="element-112">
                    Client can message you with questions expecting a response
                    in 1-2 business days, or message AI for immediate answers.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Section 2: On Your End */}
          <div className="grid md:grid-cols-[1fr_1.5fr] gap-12 md:gap-20 items-start" data-id="element-113">
            {/* Left column - heading */}
            <div className="max-w-md" data-id="element-114">
              <h3 className="text-3xl md:text-4xl font-semibold text-[#186447] mb-6 tracking-tight" data-id="element-115">
                On Your End
              </h3>
            </div>

            {/* Right column - list */}
            <div className="space-y-8" data-id="element-116">
              <div className="flex gap-4 group" data-id="element-117">
                <div className="flex-shrink-0 mt-1" data-id="element-118">
                  <div className="w-12 h-12 rounded-xl bg-[#EFFAF5] flex items-center justify-center group-hover:bg-[#186447] transition-colors" data-id="element-119">
                    <span className="text-xl font-semibold text-[#186447] group-hover:text-white transition-colors" data-id="element-120">
                      1
                    </span>
                  </div>
                </div>
                <div data-id="element-121">
                  <p className="text-base text-[#6B7280] leading-relaxed" data-id="element-122">
                    For each client, AI saves time by generating a draft plan
                    tailored to your preferences and expertise.
                  </p>
                </div>
              </div>

              <div className="flex gap-4 group" data-id="element-123">
                <div className="flex-shrink-0 mt-1" data-id="element-124">
                  <div className="w-12 h-12 rounded-xl bg-[#EFFAF5] flex items-center justify-center group-hover:bg-[#186447] transition-colors" data-id="element-125">
                    <span className="text-xl font-semibold text-[#186447] group-hover:text-white transition-colors" data-id="element-126">
                      2
                    </span>
                  </div>
                </div>
                <div data-id="element-127">
                  <p className="text-base text-[#6B7280] leading-relaxed" data-id="element-128">
                    You update and approve recommendations to ensure they
                    reflect your professional judgment.
                  </p>
                </div>
              </div>

              <div className="flex gap-4 group" data-id="element-129">
                <div className="flex-shrink-0 mt-1" data-id="element-130">
                  <div className="w-12 h-12 rounded-xl bg-[#EFFAF5] flex items-center justify-center group-hover:bg-[#186447] transition-colors" data-id="element-131">
                    <span className="text-xl font-semibold text-[#186447] group-hover:text-white transition-colors" data-id="element-132">
                      3
                    </span>
                  </div>
                </div>
                <div data-id="element-133">
                  <p className="text-base text-[#6B7280] leading-relaxed" data-id="element-134">
                    You generate additional income without adding complex
                    scheduling or administrative work.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};